import React, { Fragment } from "react";
import Field from "../../Common/Field/Field";
import Async from "react-select"

const BulkUpdateForDispatch = props => {
    const leftAlignFields = ["CUST-DEPT", "STYLENAME", "SAMPLETYPE"];

    return (
        <div class="col-md-12 " >
            <div className="col-md-12 d-flex justify-content-center" style={{ zIndex: "1001" }}>
                <div className="col-md-2 text-center">
                    <label>Date<span className="text-danger">*</span></label>
                    <Field
                        inputType="date"
                        inputName="toDate"
                        // label="to Date"
                        value={props.toDate}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control w-100"
                    />
                </div>
                <div className="col-md-2 text-center">
                    <label>AWB No.<span className="text-danger">*</span></label>
                    <Field
                        inputType="text"
                        inputName="awbNumber"
                        value={props.awbNumber}
                        onChange={props.updateState}
                        disabled={false}
                        className="w-100"
                    />
                </div>
                <div className="col-md-2 text-center">
                    <label>Location<span className="text-danger">*</span></label>
                    <Field
                        inputType="select"
                        inputName="location"
                        value={props.location}
                        options={props.LOCATION}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>

                <div className="col-md-2 text-center">
                    <label>Courier<span className="text-danger">*</span></label>
                    <Field
                        inputType="select"
                        inputName="courier"
                        value={props.courier}
                        options={props.courierOptions}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
                <div className="col-md-2 mt-4">
                    <button type="button" className="primary" onClick={() => props.bulkDispatchUpdate(props.toDate, props.awbNumber, props.location, props.courier)} >Update</button>
                </div>
            </div>

            <div class="col-md-12 text-center d-flex justify-content-center my-3" style={{ zIndex: "1000" }}>
                <div className="col-md-2 ">
                    <Async
                        name="UpdateNo"
                        options={props.NumberFromList}
                        onInputChange={props.getNumberList}
                        value={props.NumberFromObj}
                        onChange={props.getNumberFrom}
                        placeholder={`Select Request No.`}
                    />
                </div>
                <div className="col-md-2 d-flex justify-content-between">
                    <div>
                        <button
                            type="button"
                            className="primary buttonBulkUpdate"
                            onClick={props.addNumbers}
                        >Add</button>
                        <button
                            type="button"
                            className="primary mx-1 buttonBulkUpdate"
                            onClick={() => {
                                if ((!props.awbNumber || !props.location || !props.courier)) {
                                    props.getalertMessage('info', 'Please fill mandatory Fields')
                                } else {
                                    props.exportReport(false, 1)  
                                } 

                            }}
                        >
                            Search
                          </button>
                        <button
                            type="button"
                            className="primary buttonBulkUpdate"
                            onClick={props.resetBy}
                        >
                            Reset
                          </button>
                    </div>
                </div>
                <div className="col-sm-5 py-3 px-0 rounded" style={{ border: '1px solid #dee2e6' }}>

                    {props.ids.length > 0 && props.ids.map(x => (<button
                        type="button"
                        className="primary m-1"
                        onClick={() => props.removeNumbers(x.value)}
                    >{x.label}<sup>X</sup></button>))}

                </div>
            </div>
            {props.List.length > 0 && (
                <div className="col-md-12 nopadding">
                    <table id="report-list-height"
                        className="mt-5"
                    // onScroll={this.handleScroll}
                    >
                        <tbody>
                            <tr>
                                {/* <td className="report-header">All</td> */}
                                {Object.keys(props.List[0]).map(x => (x !== "id" && x !== 'selectedSize' && x !== 'selectedQty') && <td className="report-header">{x}</td>)}
                                <td className="report-header">Add</td>
                            </tr>
                            {props.List.map((data, i) => (<tr>
                                {/* <td>
                                    <Field
                                        isFormGroup={true}
                                        inputType="checkbox"
                                        inputName={data.tableKeyName}
                                        // value={column[data.tableKeyName]}
                                        // onChange={this._handleColumnCheckbox}
                                        className="mx-auto d-flex w-100 justify-content-center"
                                    />
                                </td> */}
                                {Object.keys(data).map((x) => {
                                    return (x !== "id" && x !== 'selectedSize' && x !== 'selectedQty') && (
                                        <Fragment>
                                            <td width={x === "QTY" && '8%'}
                                                className={leftAlignFields.includes(x) ? 'text-left' : ''}>
                                                {x === "SIZE" && Array.isArray(data[x])
                                                    &&
                                                    <select
                                                        onChange={(e) => props.dispatchUpdate(e.target.value, i, 'selectedSize')}
                                                        value={data['selectedSize']}
                                                    >
                                                        <option>select</option>
                                                        {data["SIZE"].map(d => (<option value={d}>{d}</option>))}
                                                    </select>
                                                    ||
                                                    x === "QTY" &&
                                                    <span className="mt-2 d-block">
                                                        <Field
                                                            isFormGroup={true}
                                                            inputType="number"
                                                            inputName={"selectedQty" + i}
                                                            value={data['selectedQty']}
                                                            onChange={(name, value) => props.dispatchUpdate(value, i, 'selectedQty')}
                                                            className="mx-auto d-flex w-100 justify-content-center"
                                                        />
                                                    </span> ||
                                                    data[x]}</td>
                                        </Fragment>
                                    )
                                })}
                                <td>
                                    <button type="button"
                                        className="primary"
                                        onClick={() => props.addDispatchData(data["SIZE"], i)}
                                    >Add</button>
                                </td>
                            </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )
            }
        </div >
    );
};

export default BulkUpdateForDispatch;


// WEBPACK FOOTER //
// ./src/components/Report/forms/BulkUpdateForDispatch.js